module.exports = __webpack_public_path__ + "img/account_outer_white.f792a606.svg";